import APIKeys from '../../components/apiKeys/APIKeys';
import { useTranslator } from 'translation/useTranslator';
import ExternalAuthenticationMethods from '../../components/externalAuthenticationMethods/ExternalAuthenticationMethods';
import { Accordion } from '@nps.today/component-library';
import { Text } from 'components/text/Text';
import { LoginConfiguration } from 'pages/authentication/components/LoginConfiguration';
import AccessGuard, { rules } from 'access';

export default function Authentication() {
  const translator = useTranslator();
  return (
    <>
      <AccessGuard rule={rules.tenant.read}>
        <LoginConfiguration />
      </AccessGuard>
      <AccessGuard rule={rules.apiKey.read}>
        <Accordion
          titleContent={<Text variant="h6">{translator.apiKeys()}</Text>}
          openOnFirstRender
        >
          <APIKeys />
        </Accordion>
      </AccessGuard>
      <Accordion
        titleContent={<Text variant="h6">{translator.externalAuthenticationMethods()}</Text>}
        openOnFirstRender
      >
        <ExternalAuthenticationMethods />
      </Accordion>
    </>
  );
}
